import axios from "axios"
import baseURL from "../configs/api"

export const put_AboutUs = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}AboutUs`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        params: {
            userId
        },
        data: data
    }).then(response => response.data);
}

export const getAboutUs = (tenantId: string) => {
    return getFetch("AboutUs", tenantId)
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}